module.exports = __webpack_public_path__ + "static/media/closed.6436dde3.svg";